var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookLibrarySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#77B3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M509.461 291.744L330.667 112.949L329.334 111.616C327.627 110.176 325.441 109.323 323.094 109.323H150.88C131.093 109.323 115.04 125.376 115.04 145.216V367.243C114.72 377.696 119.093 387.136 126.187 393.59L244.304 511.707C248.181 511.877 252.075 512 256 512C385.248 512 492.064 416.197 509.461 291.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.104 109.333H150.896C131.093 109.333 115.04 125.386 115.04 145.189V367.216C115.605 348.395 132.027 333.883 150.853 333.883H328.245C330.837 333.883 332.938 335.984 332.938 338.582V119.168C332.939 113.739 328.539 109.333 323.104 109.333Z",
    fill: "#E16B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.773 109.333H150.88V339.573H156.773V109.333Z",
    fill: "#CB6151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.413 393.275C134.805 393.275 123.082 380.678 124.538 365.782C125.807 352.795 137.482 343.286 150.527 343.286H328.244C330.836 343.286 332.937 341.185 332.937 338.587C332.937 335.995 330.836 333.888 328.244 333.888H150.853C132.021 333.888 115.605 348.4 115.04 367.221C114.453 386.698 130.069 402.666 149.413 402.666H328.25C330.842 402.666 332.943 400.565 332.943 397.967C332.943 395.375 330.842 393.268 328.25 393.268H149.413V393.275Z",
    fill: "#DC8744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.539 365.776C123.083 380.677 134.806 393.269 149.414 393.269H327.355C319.6 376.602 319.6 359.941 327.355 343.274H150.528C137.477 343.28 125.803 352.789 124.539 365.776Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 354.683H323.312C323.477 354.022 323.696 353.36 323.888 352.704H139.883V354.683Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 361.973H321.91C321.99 361.312 322.155 360.65 322.257 359.989H139.883V361.973Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 369.269H321.595C321.584 368.608 321.584 367.946 321.595 367.285H139.883V369.269Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 376.56H322.256C322.155 375.899 321.989 375.237 321.909 374.581H139.883V376.56Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.883 383.851H323.888C323.696 383.19 323.477 382.528 323.312 381.872H139.883V383.851Z",
    fill: "#E1E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.072 251.462C301.313 251.462 322.587 230.189 322.587 203.947C322.587 177.705 301.313 156.432 275.072 156.432C248.83 156.432 227.557 177.705 227.557 203.947C227.557 230.189 248.83 251.462 275.072 251.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.938 231.787C237.082 215.931 236.874 190.427 252.474 174.822C255.957 171.339 259.946 168.689 264.197 166.785C258.16 168.545 252.464 171.804 247.701 176.561C232.586 191.676 232.586 216.188 247.701 231.302C254.394 237.995 262.928 241.713 271.674 242.475C264.831 240.704 258.324 237.168 252.938 231.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.112 162.891C293.445 140.224 256.699 140.224 234.032 162.891C211.365 185.558 211.365 222.304 234.032 244.971C254.923 265.862 287.739 267.446 310.507 249.84L315.702 255.029L326.177 244.554L320.988 239.359C338.587 216.597 337.003 183.776 316.112 162.891ZM308.667 237.525C290.112 256.08 260.027 256.08 241.472 237.525C222.917 218.97 222.917 188.885 241.472 170.33C260.027 151.775 290.107 151.775 308.661 170.33C327.215 188.885 327.221 218.971 308.667 237.525Z",
    fill: "#AFC0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.992 240.661L311.803 257.85C310.827 258.826 310.827 260.41 311.803 261.386L375.627 325.215C380.07 329.658 400.8 308.927 396.358 304.484L332.534 240.66C331.557 239.685 329.973 239.685 328.992 240.661Z",
    fill: "#D8B443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.168 298.303L369.438 319.033L372.956 322.552L393.686 301.822L390.168 298.303Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.698 243.868L314.968 264.598L318.486 268.117L339.216 247.387L335.698 243.868Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookLibrarySvgrepoCom);
export default __webpack_public_path__ + "static/media/book-library-svgrepo-com.5c42df2e249e7413edbc7600541e73ad.svg";
export { ForwardRef as ReactComponent };